import { Tabs_default } from "./chunk-AH3O6RW3.js";
import { Tabs_List_default } from "./chunk-O5CGRA2A.js";
import { Tabs_Panel_default } from "./chunk-Q5GABQJN.js";
import { Tabs_Panels_default } from "./chunk-RKNYRC4X.js";
import { Tabs_Tab_default } from "./chunk-RNCTHL5H.js";

// src/components/Tabs/index.ts
var TabComponent = Tabs_default;
TabComponent.Tab = Tabs_Tab_default;
TabComponent.Tab.displayName = "Tab.Tab";
TabComponent.List = Tabs_List_default;
TabComponent.List.displayName = "Tab.List";
TabComponent.Panel = Tabs_Panel_default;
TabComponent.Panel.displayName = "Tab.Panel";
TabComponent.Panels = Tabs_Panels_default;
TabComponent.Panels.displayName = "Tab.Panels";
export { TabComponent };